import { cn } from "../../../../../utils/cn";
import { Checkbox } from "./checkbox";
import { forwardRef } from "react";

// interface CheckboxSelectionControlProps {
//   id: string;
//   checked: boolean;
//   onChange: (checked: boolean) => void;
//   label: string;
//   disabled?: boolean;
//   type?: 'checkbox' | 'check' | 'indeterminate';
// }

const CheckboxSelectionControl = forwardRef(
  (
    {
      id,
      checked,
      onChange,
      label,
      type = "checkbox",
      disabled = false,
      required = false,
      requiredMessage = false,
      ...props
    },
    ref
  ) => {
    const handleClick = () => {
      if (disabled) return;
      onChange(!checked);
    };

    return (
      <div
        className={cn(
          "group flex items-center justify-center gap-sp160 rounded-md p-sp40 outline-none",
          "focus-visible:ring-2 focus-visible:ring-semantic-focused-global-global-default overflow-hidden",
          disabled ? "cursor-not-allowed opacity-50" : "custom-cursor"
        )}
        onClick={handleClick}
        ref={ref}
        {...props}
      >
        <Checkbox
          id={id}
          checked={checked}
          onChange={onChange}
          variant={type}
          disabled={disabled}
        />
        <div className="flex items-center gap-sp80">
          <span
            className={cn(
              "select-none typography-semantic-label-1-normal---regular leading-none",
              "text-semantic-secondary-foreground-normal-default",
              !disabled && [
                "group-hover:text-semantic-secondary-foreground-normal-hovered",
                "group-active:text-semantic-secondary-foreground-normal-pressed",
              ],
              disabled && "text-semantic-secondary-foreground-normal-default"
            )}
          >
            {label}
          </span>
          {requiredMessage &&
            (required ? (
              <span className="typography-semantic-label-1-normal---regular text-semantic-error-global-global-default">
                (필수)
              </span>
            ) : (
              <span className="typography-semantic-label-1-normal---regular text-semantic-secondary-foreground-normal-default">
                (선택)
              </span>
            ))}
        </div>
      </div>
    );
  }
);

CheckboxSelectionControl.displayName = "CheckboxSelectionControl";

export default CheckboxSelectionControl;
